import { FC } from "react";
import GenericCrudTable from "@/components/tables/genericCrudTable";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import KeyIcon from "@mui/icons-material/Key";
import { useNavigate } from "react-router-dom";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import { groupEntityAdapter } from "@/components/permissions/groupEntityAdapter";

interface Props {
  title?: string;
}

const GroupCrudTable: FC<Props> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columns = [
    { header: "id", accessorKey: "id" },
    { header: t("name"), accessorKey: "name", enableForCreate: true },
    {
      header: t("is_additional"),
      accessorKey: "is_additional",
      id: "is_additional",
      checkBox: true,
      enableForCreate: true,
      accessorFn: (row: any) => (row.is_additional ? t("yes") : t("no")),
    },
  ];
  const customRowActions = (row: any) => {
    return (
      <Tooltip
        arrow
        placement="top"
        enterDelay={1000}
        enterNextDelay={250}
        title={t("group_edit_permissions", { group: row.original.name })}
      >
        <GenericButton
          variant="icon"
          color="iconBase"
          onClick={() =>
            navigate(`/permissionGroupList/${row.original.id}/edit`)
          }
        >
          <KeyIcon />
        </GenericButton>
      </Tooltip>
    );
  };

  const additionalUrlParameters: any = {};
  additionalUrlParameters["include_kaer_internal"] = true;
  return (
    <>
      <GenericCrudTable
        entity="group"
        entityAdapter={groupEntityAdapter}
        columns={columns}
        additionalUrlParameter={additionalUrlParameters}
        additionalSubmitDataForCreate={{ permissions: [] }}
        customRowActions={customRowActions}
      />
    </>
  );
};

export default GroupCrudTable;
